/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spacing-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:0 20px}\n/*# sourceMappingURL=view.component.css.map*/"];
export { styles as styles };
